import { ReactComponent as FlagIcon } from "./svg/za-flag.svg";
import "../flag-icon.scss";

export const ZAFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
